<template>
    <div class="mx-auto bg-gray-200 p-6 border-b-2 border-gray-100 rounded-b-2xl pb-1">
        <div class="flex py-6 md:justify-start md:space-x-10">
            <div class="lg:w-0 lg:flex-1">
                <a href="/" class="router-link-active">
                    <span class="sr-only">Kivid</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="114" height="40" viewBox="0 0 114 40">
                        <rect width="114" height="40" fill="none"></rect>
                        <g transform="translate(0 5.714)">
                            <path
                                d="M937.205,224.475a3.809,3.809,0,0,0-.249.309,2.215,2.215,0,0,0-.179.339,1.639,1.639,0,0,0-.11.379,1.737,1.737,0,0,0-.04.389,1.992,1.992,0,0,0,.578,1.406,2,2,0,1,0,2.822-2.822A2.075,2.075,0,0,0,937.205,224.475Zm-11.568,14.156,6.122-5.089a1.994,1.994,0,1,0-2.549-3.067l-9,7.481V225.889a1.994,1.994,0,1,0-3.988,0v20.4a1.994,1.994,0,1,0,3.988,0v-3.144l2.346-1.951,6.514,6.506a1.994,1.994,0,1,0,2.819-2.822Zm34.129-8.319a1.994,1.994,0,0,0-2.622,1.04l-4.275,9.892L948.6,231.227a1.994,1.994,0,0,0-3.67,1.563l6.087,14.293a1.994,1.994,0,0,0,1.829,1.213h.005a1.994,1.994,0,0,0,1.831-1.2l6.119-14.158A2,2,0,0,0,959.766,230.312Zm-21.148-.3a1.994,1.994,0,0,0-1.994,1.994v14.279a1.994,1.994,0,1,0,3.988,0V232.008A1.994,1.994,0,0,0,938.618,230.014Zm50.956,7.426V225.889a1.994,1.994,0,0,0-3.989,0V230.7a8.116,8.116,0,0,0-12.264,6.992v2.915a8.123,8.123,0,0,0,12.584,6.8,1.991,1.991,0,0,0,3.669-1.076v-5.472c0-.084.012-.165.012-.25V237.69C989.586,237.606,989.577,237.524,989.574,237.44Zm-3.989,3.291a4.138,4.138,0,0,1-8.275-.125V237.69a4.138,4.138,0,0,1,8.275-.125Zm-18.417-12.846a2.044,2.044,0,0,0,1.416-.588,1.991,1.991,0,0,0,.578-1.406,1.736,1.736,0,0,0-.039-.389,1.639,1.639,0,0,0-.11-.379,2.236,2.236,0,0,0-.179-.339,3.76,3.76,0,0,0-.249-.309,2.075,2.075,0,0,0-2.822,0,2.383,2.383,0,0,0-.249.309,2.215,2.215,0,0,0-.179.339,2.4,2.4,0,0,0-.12.379,2.526,2.526,0,0,0-.04.389,2,2,0,0,0,.588,1.406A2.023,2.023,0,0,0,967.168,227.885Zm0,2.129a1.994,1.994,0,0,0-1.995,1.994v14.279a1.995,1.995,0,0,0,3.989,0V232.008A1.994,1.994,0,0,0,967.172,230.014Z"
                                transform="translate(-875.587 -221.667)"
                                fill="#494949"
                            ></path>
                            <path
                                d="M864.809,249.134a1.019,1.019,0,0,1-1.082-.9.96.96,0,0,1,0-.118c-.12,0-.24,0-.361,0a16.22,16.22,0,0,1-8.075-1.934,9.8,9.8,0,0,1-4.839-7.307,10.7,10.7,0,0,1,2.458-8.624,11.568,11.568,0,0,1,8.642-4.112h.144c.24,0,.478.009.715.022a14.191,14.191,0,0,1,5.8-4.911,11.929,11.929,0,0,1,4.549-.976,8.766,8.766,0,0,1,4.067.966,7.6,7.6,0,0,1,3.9,4.482c.831,3.027-.742,6.069-2.006,8.512a4.842,4.842,0,0,0-.592,3.827,1.245,1.245,0,0,0,.538.6,2.8,2.8,0,0,1,1.887-.884l.09,0a2.126,2.126,0,0,1,1.614.716,2.178,2.178,0,0,1,.519,1.645,3.009,3.009,0,0,1-1.159,2.076,29.557,29.557,0,0,1-16.784,6.915h-.027Zm-3.258-21.613a10.193,10.193,0,0,0-7.595,3.623,9.341,9.341,0,0,0-2.15,7.529,8.481,8.481,0,0,0,4.177,6.331,14.828,14.828,0,0,0,7.368,1.751,19.718,19.718,0,0,0,2.928-.219,10.017,10.017,0,0,1-5.2-4.431,13.981,13.981,0,0,1-1.6-8.226A16.633,16.633,0,0,1,861.551,227.522Zm19.079,11.635a1.58,1.58,0,0,0-1.173.688l-.126.143c-.293.337-.587.656-.884.969l-.273.283q-.4.412-.818.8l-.053.051c-.425.4-.877.8-1.342,1.178-.3.245-.575.463-.854.673a24.971,24.971,0,0,1-4.712,2.806,28.261,28.261,0,0,0,10.324-5.57,1.73,1.73,0,0,0,.69-1.149.823.823,0,0,0-.177-.622A.789.789,0,0,0,880.63,239.157ZM863.1,227.605a15.281,15.281,0,0,0-2.26,6.426,12.539,12.539,0,0,0,1.416,7.37,7.916,7.916,0,0,0,6.586,4.2,6.288,6.288,0,0,0,.874-.062l.268-.117.331-.159c.279-.134.556-.273.829-.419.109-.058.216-.118.324-.178.3-.166.551-.312.8-.463.134-.081.268-.166.4-.25q.348-.22.689-.453c.144-.1.287-.2.43-.3q.317-.227.628-.465c.15-.116.3-.233.451-.353.194-.155.384-.314.574-.475.156-.133.311-.266.464-.4.179-.16.355-.324.53-.49.157-.148.314-.3.468-.449s.277-.281.414-.424c-1.193-.43-2.421-1.7-3.659-3.8l-.177-.274a26.417,26.417,0,0,0-4.325-5.565,11.305,11.305,0,0,0-5.466-2.808C863.5,227.655,863.3,227.629,863.1,227.605Zm.883-1.259a12.689,12.689,0,0,1,6.1,3.131,27.821,27.821,0,0,1,4.557,5.837l.195.3a11.747,11.747,0,0,0,1.865,2.495,6.627,6.627,0,0,1,.779-4.45c1.226-2.372,2.616-5.059,1.919-7.6a6.237,6.237,0,0,0-3.2-3.6,7.4,7.4,0,0,0-3.437-.811,10.542,10.542,0,0,0-4.006.864A12.6,12.6,0,0,0,863.985,226.346Z"
                                transform="translate(-850.32 -220.281)"
                                fill="#494949"
                            ></path>
                        </g>
                    </svg>
                </a>
                <ul class="pt-4 mt-4 text-gray-600 text-sm">
                    <li>Suporte: (71) 3340-2934</li>
                    <li>Vendas: (71) 3340-2934</li>
                    <li>E-mail: suporte@kivid.com.br</li>
                </ul>
            </div>
            <!-- <div>
                <div>
                    <div class="border-4 mb-2 rounded-2xl w-8 flex border-kvpurple-500"></div>
                    <h2 class="flex">
                        <div class="text-gray-600 font-semibold">
                            Resumo
                            <div>e atividades</div>
                        </div>
                    </h2>
                </div>
                <ul class="pt-2 text-gray-600 text-sm">
                    <li>Suporte: (71) 3340-2934</li>
                    <li>Vendas: (71) 3340-2934</li>
                    <li>E-mail: suporte@kivid.com.br</li>
                </ul>
            </div>
            <div>
                <div>
                    <div class="border-4 mb-2 rounded-2xl w-8 flex border-kvpurple-500"></div>
                    <h2 class="flex">
                        <div class="text-gray-600 font-semibold">
                            Resumo
                            <div>e atividades</div>
                        </div>
                    </h2>
                </div>
                <ul class="pt-2 text-gray-600 text-sm">
                    <li>Suporte: (71) 3340-2934</li>
                    <li>Vendas: (71) 3340-2934</li>
                    <li>E-mail: suporte@kivid.com.br</li>
                </ul>
            </div>
            <div>
                <div>
                    <div class="border-4 mb-2 rounded-2xl w-8 flex border-kvpurple-500"></div>
                    <h2 class="flex">
                        <div class="text-gray-600 font-semibold">
                            Resumo
                            <div>e atividades</div>
                        </div>
                    </h2>
                </div>
                <ul class="pt-2 text-gray-600 text-sm">
                    <li>Suporte: (71) 3340-2934</li>
                    <li>Vendas: (71) 3340-2934</li>
                    <li>E-mail: suporte@kivid.com.br</li>
                </ul>
            </div> -->
        </div>
        <div class="border-t-2 border-gray-400 pt-4 pb-8 text-gray-600 font-semibold">© Kivid Serviços de Informação na Internet Ltda.</div>
    </div>
</template>

<script>
// import { mapGetters, mapActions } from 'vuex';
export default {
    name: 'Footer',
    data() {
        return {};
    }
};
</script>

<style scoped></style>
